import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getMaritalList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const Marital = ({ control, name, onSelectChange, target, placeholder }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [fetchResponse, setFetchResponse] = useState([])
  console.log("datamarrage", fetchResponse)
  // const loadOptions = async () => {
  //   const data = await getMaritalList()
  //   setIsLoading(false)
  //   const response = data?.data?.map(dta => {
  //     return {
  //       ...dta,
  //       label: dta?.label && ucfirst(dta?.label),
  //       value: dta.id,
  //     }
  //   })

  //   setFetchResponse(response)
  // }
  const loadOptions = async () => {
    try {
      const response = await getMaritalList()
      if (response?.status && response.data) {
        // Convert the object with numeric keys to an array
        const dataArray = Object.values(response.data)
          .filter(item => typeof item === 'object') // Ensure we only take objects
          .map(dta => ({
            ...dta,
            label: dta?.label ? ucfirst(dta.label) : '',
            value: dta.id,
          }))
        
        setFetchResponse(dataArray)
      }
    } catch (error) {
      console.error("Error loading marital options:", error)
      setFetchResponse([])
    } finally {
      setIsLoading(false)
    }
  }
  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, ref, value },
          fieldState: { invalid },
        }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              invalid={invalid}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(
                target ? target : ".modal"
              )}
            />
          )
        }}
      />
    </div>
  )
}

export default Marital
